import { c as _c } from "react/compiler-runtime";
export const SectionLoadError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="flex min-h-192 items-center justify-center text-center text-Gray-700 typo-body3">불러오지 못했어요.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};